/* PostHog - zdarzenia interfejsu sklepu IVERESSE (Shopify, motyw Sahara), 08.10.2026. Init i kontekst: snippets/iv-posthog.liquid.
   Nazwy zdarzeń e-commerce wg specyfikacji PostHoga, reszta po polsku w props.
   Każdy klik/CTA ma "miejsce" = typ sekcji motywu (np. hero-banner, main-product, header) albo data-place.
   Nigdy nie wysyłamy treści wpisywanej przez klienta (pola formularzy, wyszukiwarka), tylko teksty interfejsu, identyfikatory i liczby.
   Budżet: darmowy plan PostHoga = 1 mln zdarzeń/mies. przy ~260 tys. odsłon (GA4, 08.09-07.10.2026), dlatego przewijanie
   i widoczność sekcji idą JEDNYM zdarzeniem "Page Engagement" na odsłonę (przy opuszczeniu strony), a nie osobnymi. */
(function () {
  if (!window.IV_PH_ON) return;
  (window.IV_PH_READY = window.IV_PH_READY || []).push(run);
  function run() {
  var ctx = window.IV_PH_CTX || {}, cur = ctx.currency || 'PLN';
  function cap(n, p, o) { try { window.posthog.capture(n, p || {}, o); } catch (e) {} }
  function txt(el) { return ((el.getAttribute('aria-label') || el.innerText || el.value || el.title || '') + '').replace(/\s+/g, ' ').trim().slice(0, 60); }
  /* miejsce = typ sekcji z klasy motywu (section-hero-banner -> hero-banner, main-product), bo ID sekcji to losowe hashe */
  function sekcja(s) {
    var c = (s.className || '').split(/\s+/), i, k;
    for (i = 0; i < c.length; i++) {
      k = c[i];
      if (k === 'main-product') return k;
      if (/^section-{1,2}/.test(k) && k !== 'section-new' && k !== 'section--') return k.replace(/^section-{1,2}/, '');
    }
    if (s.querySelector('.shopify-app-block')) return 'app_block';
    var id = s.id.replace('shopify-section-', ''), m = id.split('__')[1] || id;
    if (/^[0-9a-f]{12,}$|^[0-9a-f-]{36}$/.test(m)) return 'app_embed'; /* sekcja bez typu w klasie, ID = hash */
    return m.replace(/_[A-Za-z0-9]{6}$/, '');
  }
  function miejsce(el) {
    if (!el || !el.closest) return ctx.page_type;
    var dp = el.closest('[data-place]'); if (dp) return dp.getAttribute('data-place');
    if (el.closest('cart-drawer, .cart-drawer')) return 'cart_drawer';
    if (el.closest('product-sticky-atc')) return 'sticky_atc';
    if (el.closest('header-drawer')) return 'menu_mobile';
    if (el.closest('predictive-search')) return 'wyszukiwarka';
    var s = el.closest('[id^="shopify-section-"]'); if (!s) return 'poza_sekcja';
    return sekcja(s);
  }
  function path(h) { try { var u = new URL(h, location.href); return u.host === location.host ? u.pathname : u.host + u.pathname; } catch (e) { return ''; } }
  var lastClick = { m: null, v: null, t: 0 };

  /* ---- widoki ---- */
  var P = ctx.product, C = ctx.collection;
  if (P) cap('Product Viewed', { product_id: String(P.product_id), variant_id: String(P.variant_id), sku: P.sku, name: P.name, category: P.category, brand: P.brand, variant: P.variant, price: P.price, currency: cur, url: location.pathname, available: P.available });
  if (C && ctx.page_type === 'collection') cap('Product List Viewed', { list_id: C.handle, category: C.name, count: C.count, page: C.page });
  if (ctx.search) cap('Products Searched', { results: ctx.search.results });
  if (ctx.page_type === 'cart') cap('Cart Viewed', { miejsce: 'cart_page', value: ctx.cart_value, count: ctx.cart_count, currency: cur });
  if (ctx.page_type === '404') cap('Page Not Found', { path: location.pathname, referrer: document.referrer || null });

  /* ---- koszyk (fetch przechwycony w snippecie) ---- */
  var lastAdd = '';
  window.IV_PH_CART = function (url, body, j) {
    var recent = Date.now() - lastClick.t < 5000, place = recent ? lastClick.m : ctx.page_type;
    if (/\/cart\/add/.test(url)) {
      if (j && j.status) { cap('Add To Cart Failed', { miejsce: place, kod: j.status }); return; }
      var items = j && j.items ? j.items : [j];
      items.forEach(function (i) {
        if (!i || !i.variant_id) return;
        var key = i.variant_id + ':' + i.quantity + ':' + Math.floor(Date.now() / 1500);
        if (key === lastAdd) return; lastAdd = key;
        cap('Product Added', { product_id: String(i.product_id), variant_id: String(i.variant_id), sku: i.sku, name: i.product_title, variant: i.variant_title, price: (i.final_price || i.price) / 100, quantity: i.quantity, currency: cur, url: i.url, miejsce: place });
      });
      return;
    }
    var q = null, line = null;
    try { var b = typeof body === 'string' ? JSON.parse(body) : (body && body.get ? { quantity: body.get('quantity'), line: body.get('line'), id: body.get('id') } : body); q = b && b.quantity != null ? +b.quantity : null; line = b && (b.line || b.id); } catch (e) {}
    var vid = String(line || '').indexOf(':') > 0 ? String(line).split(':')[0] : (recent ? lastClick.v : null);
    if (q === 0) cap('Product Removed', { variant_id: vid, line: String(line || ''), miejsce: place, cart_value: j && j.total_price != null ? j.total_price / 100 : null, currency: cur });
    else cap('Cart Updated', { quantity: q, miejsce: place, cart_value: j && j.total_price != null ? j.total_price / 100 : null, currency: cur });
  };

  /* ---- kliknięcia: CTA z miejscem, karta produktu, przejście do kasy ---- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a, button, [role="button"], input[type="submit"], summary');
    if (!el) return;
    var m = miejsce(el), href = el.getAttribute('href'), vm = href && href.match(/[?&]id=(\d+)/);
    lastClick = { m: m, v: vm ? vm[1] : null, t: Date.now() };
    var express = el.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart');
    if (el.matches('[name="checkout"], a[href*="/checkout"]') || express) {
      cap('Checkout Clicked', { miejsce: m, kanal: express ? 'express' : 'koszyk', value: ctx.cart_value, currency: cur }, { transport: 'sendBeacon' });
      return;
    }
    var pm = href && path(href).match(/\/products\/([^/?#]+)/);
    if (pm && !(P && P.handle === pm[1])) {
      var cards = el.closest('[id^="shopify-section-"]'), all = cards ? [].slice.call(cards.querySelectorAll('a[href*="/products/"]')) : [];
      var seen = {}, uniq = all.filter(function (a) { var h = path(a.getAttribute('href')); if (seen[h]) return false; seen[h] = 1; return true; });
      cap('Product Clicked', { handle: pm[1], miejsce: m, pozycja: uniq.map(function (a) { return path(a.getAttribute('href')); }).indexOf(path(href)) + 1 || null, page_type: ctx.page_type }, { transport: 'sendBeacon' });
      return;
    }
    cap('CTA Clicked', { miejsce: m, tekst: txt(el), typ: el.tagName === 'A' ? 'link' : 'przycisk', cel: href ? path(href) : null, page_type: ctx.page_type }, href ? { transport: 'sendBeacon' } : undefined);
  }, true);

  /* ---- wybór wariantu (rozmiar/kolor = nazwa wariantu z katalogu, nie treść klienta) ---- */
  document.addEventListener('change', function (e) {
    var el = e.target; if (!P || !el.closest || !el.closest('form[action*="/cart/add"], product-selector, variant-selects, variant-radios, product-sticky-atc')) return;
    if (!/^options\[/.test(el.name || '') && !(el.tagName === 'SELECT' && el.name === 'id')) return;
    var v = el.tagName === 'SELECT' ? (el.options[el.selectedIndex] || {}).text : el.value;
    cap('Variant Selected', { product_id: String(P.product_id), opcja: (el.name || '').replace(/^options\[|\]$/g, ''), wariant: (v || '').trim().slice(0, 60), miejsce: miejsce(el) });
  }, true);

  /* ---- szuflada koszyka (<cart-drawer> w motywie Sahara dostaje klasę is-visible) ---- */
  var drawer = document.querySelector('cart-drawer'), lastOpen = 0;
  if (drawer && window.MutationObserver) new MutationObserver(function () {
    var open = drawer.classList.contains('is-visible') || drawer.classList.contains('active') || drawer.hasAttribute('open');
    if (open && Date.now() - lastOpen > 2000) { lastOpen = Date.now(); cap('Cart Viewed', { miejsce: 'cart_drawer', page_type: ctx.page_type, currency: cur }); }
  }).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });

  /* ---- ocena układu: jedno zdarzenie na odsłonę - max przewinięcie, sekcje zobaczone, czas ---- */
  var secs = [].slice.call(document.querySelectorAll('[id^="shopify-section-template--"]')).filter(function (s) { return s.offsetHeight > 40; });
  var seenSec = {}, order = [], maxPct = 0, t0 = Date.now(), sent = false;
  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; var s = en.target, m = sekcja(s); io.unobserve(s);
        if (!seenSec[m]) { seenSec[m] = secs.indexOf(s) + 1; order.push(m); }
      });
    }, { threshold: 0.3 });
    secs.forEach(function (s) { io.observe(s); });
  }
  var st; window.addEventListener('scroll', function () {
    clearTimeout(st); st = setTimeout(function () {
      var h = document.documentElement, max = h.scrollHeight - h.clientHeight; if (max < 200) return;
      maxPct = Math.max(maxPct, Math.min(100, Math.round(100 * (window.scrollY || h.scrollTop) / max)));
    }, 200);
  }, { passive: true });
  function flush() {
    if (sent) return; sent = true;
    var sek = Math.round((Date.now() - t0) / 1000); if (sek < 2) return;
    cap('Page Engagement', { page_type: ctx.page_type, szablon: ctx.template, scroll_max: maxPct, scroll_bucket: maxPct >= 90 ? 90 : maxPct >= 75 ? 75 : maxPct >= 50 ? 50 : maxPct >= 25 ? 25 : 0,
      sekcje_widziane: order, sekcji_widzianych: order.length, sekcji_na_stronie: secs.length, ostatnia_sekcja: order[order.length - 1] || null, sekundy: sek }, { transport: 'sendBeacon' });
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);

  /* ---- Klaviyo (popup/newsletter, bez adresu e-mail) ---- */
  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {}, map = { open: 'Popup Shown', embedOpen: 'Popup Shown', close: 'Popup Closed', submit: 'Newsletter Subscribed', stepSubmit: 'Popup Step Submitted' };
    if (map[d.type]) cap(map[d.type], { form_id: d.formId, miejsce: d.type === 'embedOpen' ? 'klaviyo_embed' : 'klaviyo_popup', page_type: ctx.page_type });
  });
}
})();
